export const COMPANY = {
  name: "RM Plomberie Chauffage VMC",
  shortName: "RM Plomberie",
  founder: "Ramzi Latrach",
  phone: "07 67 62 44 36",
  phoneTel: "+33767624436",
  email: "plomberierm68@gmail.com",
  address: "9 Rue de Hoen, 68980 Beblenheim",
  street: "9 Rue de Hoen",
  postalCode: "68980",
  city: "Beblenheim",
  zone: "Beblenheim • Colmar • Mulhouse • Strasbourg et alentours",
  siren: "891 654 949",
  siret: "891 654 949 00025",
  domain: "rmplomberiechauffagevmc.com",
  mapsQuery: "9+Rue+de+Hoen+68980+Beblenheim",
};

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/nos-services", label: "Nos services" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/a-propos", label: "À propos" },
  { to: "/google-business", label: "Google Business" },
  { to: "/contact", label: "Contact" },
];

export const HERO_POINTS = [
  "Disponibilité 7j/7 • 24h/24",
  "Déplacement gratuit",
  "Intervention rapide",
  "Travail soigné",
];

export const SERVICES = [
  {
    key: "plomberie",
    title: "Plomberie",
    subtitle: "Installation, rénovation et dépannage de vos réseaux d'eau.",
    image: "https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=900&q=80&auto=format&fit=crop",
    items: [
      "Installation et rénovation complète",
      "Recherche et réparation de fuites",
      "Salle de bain et cuisine",
      "Robinetterie et sanitaire",
      "Ballon d'eau chaude",
      "Débouchage de canalisations",
    ],
  },
  {
    key: "chauffage",
    title: "Chauffage",
    subtitle: "Solutions de chauffage performantes et économiques.",
    image: "https://images.pexels.com/photos/29226620/pexels-photo-29226620.jpeg?w=900&auto=compress&cs=tinysrgb",
    items: [
      "Installation chaudière",
      "Entretien et dépannage",
      "Radiateurs",
      "Plancher chauffant",
      "Pompe à chaleur",
      "Remplacement d'équipements",
    ],
  },
  {
    key: "vmc",
    title: "VMC & Ventilation",
    subtitle: "Une ventilation efficace pour un air sain au quotidien.",
    image: "https://images.pexels.com/photos/33388390/pexels-photo-33388390.jpeg?w=900&auto=compress&cs=tinysrgb",
    items: [
      "Installation VMC simple et double flux",
      "Entretien VMC",
      "Dépannage ventilation",
      "Qualité de l'air",
      "Traitement humidité",
    ],
  },
];

export const PROJECTS = [
  { title: "Rénovation salle de bain", category: "Salle de bain", location: "Colmar", image: "https://images.pexels.com/photos/19666087/pexels-photo-19666087.jpeg?auto=compress&cs=tinysrgb&w=940" },
  { title: "Installation chaudière gaz", category: "Chauffage", location: "Wintzenheim", image: "https://images.pexels.com/photos/9551366/pexels-photo-9551366.jpeg?w=940&auto=compress&cs=tinysrgb" },
  { title: "Installation VMC double flux", category: "VMC", location: "Turckheim", image: "https://images.pexels.com/photos/33388390/pexels-photo-33388390.jpeg?w=940&auto=compress&cs=tinysrgb" },
  { title: "Plancher chauffant", category: "Chauffage", location: "Ingersheim", image: "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=940&q=80&auto=format&fit=crop" },
  { title: "Création salle de bain", category: "Salle de bain", location: "Horbourg-Wihr", image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=940&q=80&auto=format&fit=crop" },
  { title: "Rénovation réseau d'eau", category: "Plomberie", location: "Colmar", image: "https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=940&q=80&auto=format&fit=crop" },
  { title: "Installation radiateur", category: "Chauffage", location: "Andolsheim", image: "https://images.unsplash.com/photo-1518276779712-dfdcb9daa7a1?w=940&q=80&auto=format&fit=crop" },
  { title: "Mise aux normes plomberie", category: "Plomberie", location: "Sundhoffen", image: "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=940&q=80&auto=format&fit=crop" },
  { title: "Installation pompe à chaleur", category: "Chauffage", location: "Zimmerbach", image: "https://images.unsplash.com/photo-1632431657479-08c4fe137c7e?w=940&q=80&auto=format&fit=crop" },
];

export const PROJECT_CATEGORIES = ["Tout", "Plomberie", "Chauffage", "VMC", "Salle de bain"];

export const VALUES = [
  { label: "Proximité", text: "Artisan local engagé sur tout le Haut-Rhin." },
  { label: "Réactivité", text: "Intervention rapide pour vos urgences." },
  { label: "Devis clair", text: "Tarifs transparents, sans surprise." },
  { label: "Travail propre", text: "Finitions soignées et chantier rangé." },
  { label: "Conseils personnalisés", text: "Une solution adaptée à votre besoin." },
];

export const REQUEST_TYPES = [
  "Dépannage urgent",
  "Devis plomberie",
  "Devis chauffage",
  "Devis VMC",
  "Entretien chaudière",
  "Rénovation salle de bain",
  "Autre",
];
